import $ from 'jquery';

const autocompleteSearch = (seachTerm) => {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: '/api/AktivBrokerSearch/Search',
      dataType: 'json',
      data: {
        'term': seachTerm, //  query term
      },
      success: (data) => {
        const hits = data.AktivSitecoreSearchResultList.map((hit) => {
          return { value: hit.Name, url: hit.Url };
        });
        resolve(hits);
      },
      error: () => {
        reject();
      },
    });
  });
};

export { autocompleteSearch };
